"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinkStyle = exports.getButtonStyle = exports.actionFormatter = void 0;
/**
 * Function for button action style
 * @function actionFormatter
 * @param { object } action - returns an object with the appropriate actionType and style attributes
 */
const actionFormatter = (data, methods) => {
  const {
    /* ActionGroup props */
    action,
    fullyClickableParent,
    isKnockoutLink,
    textForScreenReaders,
    // used when a component is fully clickable. If false will add a tab-index = -1 to avoid duplicate links for ADA
    /* ActionGroupDefault props */
    derivedAriaLabel,
    style,
    /* ActionGroupMulti props */
    hasOneAction,
    index,
    types
  } = data;
  const {
    getButtonMarkup,
    getLinkMarkup
  } = methods;

  /* ActionGroupMulti stylings */
  let {
    buttonStyle,
    linkStyle
  } = data;
  if (!action.label) {
    return null;
  }
  const isLink = !!action.url || !!action.achnorId || !!action.href;

  /* ActionGroupMulti stylings */
  const buttonAsLink = !isLink && types === 'link';
  const linkAsButton = isLink && types === 'button';

  /* ActionGroupDefault stylings */
  let actionStyle = '';

  /* Link or Button styling to send back */
  let formattedAction = {};

  /**
    Checks if action is a button as a link and
    sets style accordingly if so.
  */
  if (buttonAsLink) {
    buttonStyle = {
      variant: 'link',
      size: 'compact'
    };
  }

  /**
    Checks if action is a link as a button and
    sets style accordingly if so.
  */
  if (linkAsButton) {
    linkStyle = {
      variant: 'buttonSecondary',
      size: 'tiny'
    };
  }
  if (isLink) {
    actionStyle = getLinkStyle(style);
    formattedAction = getLinkMarkup({
      action,
      actionStyle,
      derivedAriaLabel,
      fullyClickableParent,
      hasOneAction,
      index,
      isKnockoutLink,
      textForScreenReaders,
      linkStyle
    });
  } else {
    actionStyle = getButtonStyle(style);
    formattedAction = getButtonMarkup({
      action,
      actionStyle,
      buttonStyle,
      derivedAriaLabel,
      fullyClickableParent,
      hasOneAction,
      index,
      isKnockoutLink,
      textForScreenReaders
    });
  }
  return formattedAction;
};

/**
 * Function for button action style
 * @function getButtonStyle
 * @param { string } style - returns the string to be passed as the variant in button
 */
exports.actionFormatter = actionFormatter;
const getButtonStyle = style => {
  switch (style) {
    case 'Primary Button':
      return 'primary';
    case 'Secondary Button':
      return 'secondary';
    case 'Tertiary Button':
      return 'tertiary';
    case 'Primary Button Inverse':
      return 'primaryInverse';
    case 'Primary Link':
      return 'link';
    case 'Arrow Link':
      return 'linkArrow';
  }
};

/**
 * Function for button action style
 * @function getLinkStyle
 * @param { string } style - returns the string to be passed as the variant in button
 */
exports.getButtonStyle = getButtonStyle;
const getLinkStyle = style => {
  switch (style) {
    case 'Primary Link':
      return 'primary';
    case 'Primary Button':
      return 'buttonPrimary';
    case 'Secondary Button':
      return 'buttonSecondary';
    case 'Tertiary Button':
      return 'buttonTertiary';
    case 'Arrow Link':
      return 'arrow';
  }
};
exports.getLinkStyle = getLinkStyle;